import { useState, useCallback } from 'react';
import { DEMO_USERS } from '../../data/mockData';
import { safeGet, safeSet, safeRemove } from '../../utils/safeStorage';
import { STORAGE_KEYS } from './storageKeys';

export function useAuthState() {
  const [user, setUser] = useState(() => safeGet(STORAGE_KEYS.user, null));

  const login = useCallback((roleId, departmentId = null) => {
    let demo;
    if (roleId === 'department_head' && departmentId) {
      demo = DEMO_USERS.find((u) => u.role === 'department_head' && u.department === departmentId);
    }
    if (!demo) {
      demo = DEMO_USERS.find((u) => u.role === roleId) || DEMO_USERS[0];
    }
    setUser(demo);
    safeSet(STORAGE_KEYS.user, demo);
    return demo;
  }, []);

  /** Direct login for hierarchy-aware UI: pass a DEMO_USERS userId. */
  const loginAsUser = useCallback((userId) => {
    const demo = DEMO_USERS.find((u) => u.userId === userId);
    if (!demo) return null;
    setUser(demo);
    safeSet(STORAGE_KEYS.user, demo);
    return demo;
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    safeRemove(STORAGE_KEYS.user);
  }, []);

  return { user, login, loginAsUser, logout };
}
